import { render } from "./EmailSidebar.vue?vue&type=template&id=9d47f288&scoped=true&ts=true"
import script from "./EmailSidebar.vue?vue&type=script&lang=ts"
export * from "./EmailSidebar.vue?vue&type=script&lang=ts"

import "./EmailSidebar.vue?vue&type=style&index=0&id=9d47f288&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d47f288"]])

export default __exports__